module.exports = __webpack_public_path__ + "img/v12-retail-logo.242a1889.png";